export var RelationType;
(function (RelationType) {
    RelationType[RelationType["None"] = 0] = "None";
    RelationType[RelationType["And"] = 1] = "And";
    RelationType[RelationType["Or"] = 2] = "Or";
})(RelationType || (RelationType = {}));
